import { ReactNode } from 'react';
import { MenuCloseIcon } from '@pmi/dsm-react/dist/components/icons/16';
import { IconMap } from './customIcons';
import { AlertMessage } from './models';

interface Props {
  message: AlertMessage;
  onAlertClose?: (alert: AlertMessage) => void;
  textContent?: string;
  children?: ReactNode;
}

export default function CustomAlert({
  message,
  onAlertClose = null,
  textContent = null,
  children = null,
}: Props) {
  return (
    <div
      role="alert"
      className={`fade alert alert-${message.type} show`}
      key={`alert_${message.id}`}
    >
      <div>{IconMap[message.type]()}</div>
      <div className="alert-content text-wrap text-break">
        {textContent && (
          <span
            className="alert-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: textContent }}
          />
        )}
        {children}
      </div>
      {onAlertClose && (
        <button
          type="button"
          aria-label="x"
          className="btn btn-dismiss-alert"
          onClick={() => onAlertClose(message)}
        >
          <MenuCloseIcon />
        </button>
      )}
    </div>
  );
}
